<template>
  <div class="selectItems">
    <span
      v-for="(i, index) in items"
      :key="i.key"
      :class="{
        activeItem: active === index,
        inActiveLeft: active !== index && index == 1,
        inActiveRight: active !== index && index == 0,
      }"
      @click="handleClick(index, i.key)"
    >
      {{ i.title }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    handleClick(index, key) {
      //点击事件
      this.active = index;
      this.$emit('handleClick', key); //回调事件
    },
  },
};
</script>
<style lang="scss" scoped>
.selectItems {
  display: flex;
  font-size: 14px;
  color: #999999;
  span {
    width: 56px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  .activeItem {
    color: $primary-color;
    border: 1px solid $primary-color;
  }
  .inActiveLeft {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -3px;
  }
  .inActiveRight {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: -3px;
  }
}
</style>
